import cn from "@/util/cn";
import { ComponentPropsWithoutRef, ReactNode } from "react";

type InfoBoxProps = ComponentPropsWithoutRef<"div">;

const InfoBox = ({ className, children, ...otherProps }: InfoBoxProps) => (
  <div
    className={cn("flex flex-col rounded-md border border-gray-200 bg-gray-50 p-4", className)}
    {...otherProps}
  >
    {children}
  </div>
);

type HeaderProps = ComponentPropsWithoutRef<"h1">;

InfoBox.Header = ({ className, children, ...otherProps }: HeaderProps) => (
  <h1
    className={cn("overflow-visible text-nowrap text-xl text-primary/90", className)}
    {...otherProps}
  >
    {children}
  </h1>
);

type LineProps = {
  label: ReactNode;
  value: ReactNode;
  truncate?: boolean;
};

InfoBox.Lines = ({ children, className, ...otherProps }: ComponentPropsWithoutRef<"dl">) => (
  <dl className={cn("grid grid-cols-[auto_1fr] gap-y-1", className)} {...otherProps}>
    {children}
  </dl>
);

InfoBox.Line = ({ label, value, truncate = true }: LineProps) => (
  <>
    <dt className={cn("overflow-visible text-nowrap text-primary/60")}>{label}</dt>
    <dd className={cn("overflow-visible text-primary/90", truncate && "truncate")}>{value}</dd>
  </>
);

export default InfoBox;
